import { render, staticRenderFns } from "./SliderColor.vue?vue&type=template&id=373989e3&"
import script from "./SliderColor.vue?vue&type=script&lang=js&"
export * from "./SliderColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports